// extracted by mini-css-extract-plugin
export var errorIcon = "_mi-1";
export var nameLogo = "_mi-0";